import axios from "axios";
import * as ActionType from "./gift.type";
import { apiInstanceFetch } from "../../../util/api";
import { setToast } from "../../../util/toast";

export const getGift = () => (dispatch) => {
  apiInstanceFetch
    .get(`gift/getAllGifts`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_GIFT,
        payload: res.gifts,
      });
    })
    .catch((error) => console.error(error));
};

// CREATE_GIFT
export const createGift = (formData) => (dispatch) => {
  axios
    .post(`gift/create`, formData)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.CREATE_GIFT,
          payload: res.data.gift,
        });
        setToast("success", "Gift created successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
      setToast("error", "Failed to create gift");
    });
};

// UPDATE_GIFT
export const updateGift = (formData, id) => (dispatch) => {
  axios
    .patch(`gift/update?giftId=${id}`, formData)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_GIFT,
          payload: { data: res.data.gift, id },
        });
        setToast("success", "Gift updated successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
      setToast("error", "Failed to update gift");
    });
};

// DELETE_GIFT
export const deleteGift = (id) => (dispatch) => {
  axios
    .delete(`gift/delete?giftId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.DELETE_GIFT,
          payload: id,
        });
        setToast("success", "Gift deleted successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
      setToast("error", "Failed to delete gift");
    });
};
